export default "__VITE_PUBLIC_ASSET__1d725eb9__"